import {ProgressIndicator as PeacockProgressIndicator} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').IProgressIndicatorProps} ProgressIndicatorProps
 * @property {2 | 3 | 4 | 5 | 6} [steps] Determines the number of steps to render. Defaults to 2.
 * @property {1 | 2 | 3 | 4 | 5} [currentStep] One-based; determines the current step to render. Defaults to 1.
 * @property {{ title?: string; description?: string; }[]} [titles] When provided, shows step titles. Array length should match steps count.
 * @property {boolean} completed When true, renders the current step as a completed step.
 * @property {boolean} [showStepNumber] When present, renders the step number.
 * @property {'horizontal' | 'vertical'} [orientation] Orientation of the progress indicator.
 * @property {(stepData: object) => void} [onStepClick] Global onClick handler for all steps.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS ProgressIndicator.
 * Supports all Peacock DS ProgressIndicator props.
 * @param {ProgressIndicatorProps} props
 */
export const ProgressIndicator = props => {
  return <PeacockProgressIndicator {...props} />
}
